"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppError = void 0;
// TODO: how do we want to deal with AppError?
class AppError extends Error {
    constructor(code, message, details) {
        super(`${code}: ${message ?? ''} ${details ? JSON.stringify(details, null, 2) : ''}`);
        this.code = code;
    }
    static isError(error, code) {
        return true;
    }
}
exports.AppError = AppError;
//# sourceMappingURL=AppError.js.map